// IE 2026 09 24 / ODOO-341407 (поручение Игоря: «при переключении языка не перегружался интерфейс фронтенда, только обновлялись
// заголовки, не терялось открытое, включая несохранённые правки»): перелокализация НА КЛИЕНТЕ подписей, которые бэк отдаёт уже
// локализованными (attrs видов, командные панели, меню столов/страниц, чипсы, панель параметров, заголовки виджетов/столов).
//
// Зеркало бэка (common_modules/attrs.py, _i18n_apply / localize_attr / localize_params_titles / record_title_localized /
// localize_record_meta / localize_widget_titles / localize_record_menu): у переведённого объекта пометка _i18n = '<lang>' и бэкап
// английской базы {key}_en; смена языка = восстановить базу по бэкапам → суффиксы {key}_{lang} (title/tooltip/comment/valueStr) →
// словарь по английскому тексту для title/tooltip/placeholder/shortTitle/header (+ valueStr литеральных узлов меню и подписей
// селекторов); en — восстановление + словарь en.json только для кириллической базы. Рекурсия по спискам attrs/attrs_columns/view,
// словарям node/leftValue/rightValue и groupMenu.
//
// Словарь языка целиком — команда бэка i18n_dict_get({lang, etag}) → {status:'ok', lang, etag, dict, …} | {unchanged:true};
// кэш IndexedDB 'fe-i18n' (по etag) + память. Данные гридов (_doc.data, строки, ячейки, _meta.modified, выделение, скролл, формы)
// НЕ трогаются: реактивные объекты стора мутируются на месте, шаблоны перерисовываются сами. Строки, которые бэк подписывает в
// ДАННЫХ отчётов (месяцы / итоги / меры DL2) — штатный select («Refresh data») у отчётов активной страницы без несохранённых правок
// (fe.i18n.switchRefreshData, по умолчанию вкл.); отчёты с правками остаются до следующего обновления (уведомление).
// IE 2026 09 24 / ODOO-341407: отчёты остальных открытых страниц — тем же правилом при активации своей страницы (i18nRefreshOnActivate).
// IE 2026 09 24 / ODOO-341407: то же — списки widget_LIST (Гант движений, Chart, Geo map, Metrics, колонки из doc.viewList): _dataKind, refreshDataWidgets.
import { reactive } from 'vue'   // IE 2026 09 25 / ODOO-341407: состояние индикатора хода переключения (switchProgress)
import { LANGUAGE_DEFAULT, LANGUAGE_IDS, LANGUAGES, t as tFe, tn as tnFe, bumpLangVersion, emitChanged, retranslate, getLanguage } from './index'   // IE 2026 09 24 / ODOO-341407: getLanguage — перезапрос отчётов при активации страницы; IE 2026 09 25: LANGUAGES — название языка в индикаторе

export const I18N_KEYS = ['title', 'tooltip', 'comment', 'valueStr']
export const I18N_DICT_KEYS = ['title', 'tooltip', 'placeholder', 'shortTitle', 'header']
export const CHILD_LISTS = ['attrs', 'attrs_columns', 'view']
export const CHILD_DICTS = ['node', 'leftValue', 'rightValue']
// IE 2026 09 24 / ODOO-341407: зеркало бэка attrs.I18N_RECORD_ROW_KEYS / I18N_RECORD_PARAM_KEYS (localize_record_rows) — doc.<key> / doc.params.<key>;
// doc.params.WHERE виджета НЕ трогаем: подписи чипсов ведёт своя логика (chipsKeep_relabel, deep-watcher AttrChips), здесь — только строки-определения полей
const RECORD_ROW_KEYS = ['viewList', 'view', 'fields', 'pages', 'data_tasks']
const RECORD_PARAM_KEYS = ['attrs']
const MARK = '_i18n'
const AUTO_MARK = '_i18n_auto'
const CYR_RE = /[А-Яа-яЁёІіЇїЄєҐґ]/
const ALL_KEYS = [...I18N_KEYS, ...I18N_DICT_KEYS.filter(k => !I18N_KEYS.includes(k))]
const WIDGET_TITLE_KEYS = ['shortTitle', 'recordTitle', 'segmentTitle', 'INFO_title', 'INFO_id']
// служебный префикс уведомления TERMINAL: статус + метка времени (attrs.t_notification)
const NOTIFICATION_PREFIX_RE = /^((?:!{1,3}(?:WARNING|ERROR|CRITICAL) )?(?:\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d+)? )?)([\s\S]*)$/

// ---------------- IE 2026 09 25 / ODOO-341407 (замечания пользователей через Игоря 25.09: «медленно», «не всегда понятно, когда переключение
// выполнено полностью», «иногда теряется функционал — в отчёте не показываются прошлые периоды»): флаги живого переключения ----------------
// Каждое ускорение / исправление — свой флаг, по умолчанию ВКЛ (правило 8): fe.i18n.<имя> — window.i18nSwitch.get() / .set('<имя>', false) /
// .reset() / .last() (замеры последнего переключения), URL ?fe.i18n.<имя>=false, настройки базы. Прежние флаги (switchWithoutReload,
// switchRefreshData, switchRelabelData) — в том же списке
export const SWITCH_FLAGS = {
    switchWithoutReload: 'language switch without a page reload',
    switchRefreshData: 'data widgets (reports, lists) are re-requested — their data labels are built by the backend',
    switchRelabelData: 'record titles by id (rail, pages panel, settings tree, grid rows) and reference dictionaries are re-read',
    switchDictPrefetch: 'backend dictionaries are requested at the click, in parallel with the switch of the interface strings',
    switchDictCache: 'a cached backend dictionary is used at once, its version (etag) is re-checked in the background',
    switchNoRepeat: 'a widget cache key issued under another language is dropped before the request: one full request instead of repeatFullRequest and a second one',
    switchRefreshModified: 'a data widget with changed settings or view state (no data corrections) is re-requested like Update data does — before, it stayed on the previous language',
    switchDictsScoped: 'dictionaries used on the active page are re-read first; the others — in the background after the data widgets',
    switchDictsCoalesce: 'grids redraw once for all re-read dictionaries instead of once per dictionary',
    switchDictsAfterData: 'dictionaries used on the page are re-read after the data widgets of the page are updated — they do not compete with them for the backend',
    switchProgress: 'progress indicator of the switch: widgets updated, time, errors',
    foldKeysBase: 'fold state of column groups is keyed by base (English) titles and survives a language switch',
    // IE 2026 09 26 / ODOO-341407: первая загрузка — решение о языке на первом ответе с настройками базы (store.i18n_firstLoadHold); замер — window.i18n.stats().firstLoad
    firstLoadHold: 'first load: when the database language arrives and the page must reload, the page is not built (no widget requests) and the reload is immediate instead of 1.5 s later',
    // IE 2026 11 02 / ODOO-350612: вход паролем — перезагрузка на маршрут базы, не на форму входа
    loginHoldTarget: 'password sign-in: when the user language requires a reload, the page reloads on the database route (the session is restored from the cookie) instead of the sign-in form',
}
export function switchFlag(store, name) {
    try { return store.setting('fe.i18n.' + name, true) !== false } catch (e) { return true }
}
function _flags(store) { return Object.fromEntries(Object.keys(SWITCH_FLAGS).map(k => [k, switchFlag(store, k)])) }
// ключ серверного кэша виджета (widgets.widget_cache_key_new бэка): язык — в хвосте после '@'; выдан под другой язык — бэк ответит repeatFullRequest
export function cacheKeyLangStale(key, lang) {
    if (typeof key !== 'string' || !key) return false
    const i = key.lastIndexOf('@')
    const kl = i >= 0 ? key.slice(i + 1) : ''
    return LANGUAGE_IDS.includes(kl) && kl !== (lang || getLanguage() || LANGUAGE_DEFAULT)
}
// window.i18nSwitch — консоль флагов и замеров (зовёт main.js)
export function installSwitchConsole(store) {
    try {
        window.i18nSwitch = {
            get: () => _flags(store),
            help: () => ({ ...SWITCH_FLAGS }),
            set(name, value) {
                if (!(name in SWITCH_FLAGS)) { console.warn(`i18nSwitch: no option '${name}'. Options:`, Object.keys(SWITCH_FLAGS)); return }
                if (window.feSettings && typeof window.feSettings.set === 'function') window.feSettings.set('fe.i18n.' + name, value)
                return this.get()
            },
            reset(name) {
                for (const k of (name ? [name] : Object.keys(SWITCH_FLAGS))) { try { window.feSettings.unset('fe.i18n.' + k) } catch (e) { /* без feSettings */ } }
                return this.get()
            },
            last: () => _lastRun,
            progress: () => JSON.parse(JSON.stringify(switchProgress)),
        }
    } catch (e) { /* без window */ }
}

// ---------------- словарь бэка: i18n_dict_get + кэш ----------------
const DB_NAME = 'fe-i18n', STORE = 'dicts'
const _mem = {}   // lang → entry {lang, etag, dict, size, at, _rev}

function _idb() {
    return new Promise((resolve) => {
        try {
            if (typeof indexedDB === 'undefined') return resolve(null)
            const req = indexedDB.open(DB_NAME, 1)
            req.onupgradeneeded = () => { try { req.result.createObjectStore(STORE) } catch (e) { /* уже есть */ } }
            req.onsuccess = () => resolve(req.result)
            req.onerror = () => resolve(null)
            req.onblocked = () => resolve(null)
        } catch (e) { resolve(null) }
    })
}
async function _cacheGet(lang) {
    const db = await _idb()
    if (!db) return null
    return new Promise((resolve) => {
        try {
            const rq = db.transaction(STORE, 'readonly').objectStore(STORE).get(lang)
            rq.onsuccess = () => resolve(rq.result && rq.result.dict ? rq.result : null)
            rq.onerror = () => resolve(null)
        } catch (e) { resolve(null) }
    })
}
async function _cachePut(lang, entry) {
    const db = await _idb()
    if (!db) return false
    return new Promise((resolve) => {
        try {
            const { _rev, ...plain } = entry   // eslint-disable-line no-unused-vars -- обратная карта в кэш не пишется
            const tx = db.transaction(STORE, 'readwrite')
            tx.objectStore(STORE).put(plain, lang)
            tx.oncomplete = () => resolve(true)
            tx.onerror = () => resolve(false)
        } catch (e) { resolve(false) }
    })
}

// IE 2026 09 25 / ODOO-341407: запрос словаря в полёте — общий (предзагрузка по клику, switchDictPrefetch, и relocalize ждут один ответ)
const _inflight = {}
const _revalidated = {}   // IE 2026 09 25 / ODOO-341407: lang → время фоновой перепроверки etag (не чаще раза в 30 с)
export function dictGet(store, lang, opts = {}) {
    if (_inflight[lang]) return _inflight[lang]
    const p = _dictGet(store, lang, opts)
    _inflight[lang] = p
    const clear = () => { if (_inflight[lang] === p) delete _inflight[lang] }
    p.then(clear, clear)
    return p
}
// IE 2026 09 25 / ODOO-341407: предзагрузка словарей бэка в момент клика по языку (флаг switchDictPrefetch) — параллельно смене строк интерфейса
export function dictPrefetch(store, langs) {
    for (const l of langs || []) { if (LANGUAGE_IDS.includes(l)) dictGet(store, l).catch(() => null) }
}
// словарь языка: память → IndexedDB (+ проверка etag на бэке) → бэк; ошибка бэка при наличии кэша — кэш с предупреждением
async function _dictGet(store, lang, { timeout = 30000, revalidate = false } = {}) {
    if (!LANGUAGE_IDS.includes(lang)) throw new Error(`i18n dict: unknown language ${lang}`)
    const t0 = performance.now()
    let cached = _mem[lang] || null
    if (!cached) { cached = await _cacheGet(lang); if (cached) _mem[lang] = cached }
    // IE 2026 09 25 / ODOO-341407 (замер dev02 25.09: проверка etag закэшированного словаря под нагрузкой переключения — 2–2,7 с в очереди бэка за
    // select'ами, проход подписей ждал её): закэшированный словарь — сразу, etag перепроверяется в фоне (новый словарь попадёт в кэш и в
    // следующее переключение). Флаг switchDictCache; без кэша — как раньше, запросом
    if (cached && !revalidate && switchFlag(store, 'switchDictCache')) {
        if (!(Date.now() - (_revalidated[lang] || 0) < 30000)) { _revalidated[lang] = Date.now(); _dictGet(store, lang, { timeout, revalidate: true }).catch(() => null) }
        console.log(`[i18n] dict ${lang}: ${Object.keys(cached.dict || {}).length} keys, cache (etag re-checked in the background), ${Math.round(performance.now() - t0)} ms`)
        return cached
    }
    const answer = await new Promise((resolve) => {
        let done = false
        const tm = setTimeout(() => { if (!done) { done = true; resolve({ status: 'timeout' }) } }, timeout)
        try {
            store.executeBackendMethod({}, { command: 'i18n_dict_get', params: { lang, etag: (cached && cached.etag) || '' } }, (a) => {
                if (done) return
                done = true; clearTimeout(tm)
                resolve(a && typeof a === 'object' ? a : {})
            })
        } catch (e) { done = true; clearTimeout(tm); resolve({ status: 'error', error: String(e) }) }
    })
    let entry = null, source = ''
    if (answer.unchanged && cached) { entry = cached; source = 'cache, etag unchanged' }
    else if (answer.status === 'ok' && answer.dict && typeof answer.dict === 'object') {
        entry = { lang, etag: answer.etag || '', dict: answer.dict, keys: answer.keys, suffix_keys: answer.suffix_keys,
            child_lists: answer.child_lists, child_dicts: answer.child_dicts, language_default: answer.language_default, at: Date.now() }
        try { entry.size = JSON.stringify(answer.dict).length } catch (e) { entry.size = -1 }
        source = 'backend'
        _mem[lang] = entry
        _cachePut(lang, entry)
    } else if (cached) { entry = cached; source = `cache (backend answered: ${answer.status || 'no status'})` }
    else throw new Error(`i18n_dict_get(${lang}): ${answer.status || 'no answer'}${answer.error ? ' — ' + answer.error : ''}`)
    const n = Object.keys(entry.dict).length
    console.log(`[i18n] dict ${lang}: ${n} keys, ${entry.size > 0 ? Math.round(entry.size / 1024) + ' KB' : '? KB'}, ${source}, ${Math.round(performance.now() - t0)} ms`)
    return entry
}

// t бэка: словарь языка; en — только для кириллического текста; массив форм → первая
// IE 2026 09 24 / ODOO-341407: + контекст c — ключ 'text|c' раньше 'text' (зеркало бэка attrs.t(text, lang, ctx))
function _makeT(entry, lang) {
    const dict = (entry && entry.dict) || {}
    return (text, c) => {
        if (typeof text !== 'string' || !text) return text
        if (lang === LANGUAGE_DEFAULT && !CYR_RE.test(text)) return text
        let v = c ? dict[`${text}|${c}`] : undefined
        if (v === undefined || v === null) v = dict[text]
        if (Array.isArray(v)) v = v[0]
        return (typeof v === 'string' && v) ? v : text
    }
}
// IE 2026 09 24 / ODOO-341407 (Igor: группа «Frozen» панели параметров вида грида под uk / ru — «Заморожено», ключ 'Frozen' занят статусом
// цикла S&OP): контекст словаря объекта вида — зеркало бэка attrs.i18n_ctx: явный attr.i18n_ctx (бэк ставит его и на вьюхи из базы),
// иначе группа с полями закрепления frozenColumns / frozenRows → 'grid' ('Frozen|grid' — «Закріплення» / «Закрепление»)
const CTX_KEY = 'i18n_ctx'
const CTX_GRID_BINDINGS = ['frozenColumns', 'frozenRows', 'frozenColumns_auto']
// IE 2026 09 25 / ODOO-341407 (вкладка порядка сортировки «Orders» — «Замовлення» / «Заказы», вкладка SQL-скрипта «CREATE» — «СТВОРИТИ» / «СОЗДАТЬ»):
// вкладка AttrTab по содержимому — грид порядка сортировки (…ORDER) → 'sort' ('Orders|sort'), поле запроса (…query) → 'sql' ('CREATE|sql' = CREATE);
// зеркало бэка attrs.I18N_CTX_TAB_BINDINGS
const CTX_TAB_BINDINGS = { ORDER: 'sort', query: 'sql' }
const CTX_KEY_RE = /^([\s\S]+)\|([a-z][a-z0-9_]*)$/   // ключ словаря с контекстом: 'Frozen|grid'
function _ctxOf(attr) {
    const c = attr[CTX_KEY]
    if (typeof c === 'string') return c
    if (!Array.isArray(attr.attrs)) return ''
    const tails = attr.attrs.filter(k => k && typeof k === 'object').map(k => String(k.binding || '').split('.').pop())
    if (tails.some(t => CTX_GRID_BINDINGS.includes(t))) return 'grid'
    if (attr.attr_type === 'AttrTab') {   // IE 2026 09 25 / ODOO-341407: 'sort' / 'sql' — только подписи вкладок
        for (const t of tails) if (Object.prototype.hasOwnProperty.call(CTX_TAB_BINDINGS, t)) return CTX_TAB_BINDINGS[t]
    }
    return ''
}
// обратная карта словаря прежнего языка: перевод → английский ключ (для строк, переведённых бэком без пометки: t() напрямую)
function _reverse(entry) {
    if (!entry) return null
    if (entry._rev) return entry._rev
    const rev = new Map()
    for (const [k, v] of Object.entries(entry.dict || {})) {
        const forms = Array.isArray(v) ? v : [v]
        for (const f of forms) if (typeof f === 'string' && f && f !== k && !rev.has(f)) rev.set(f, k)
    }
    entry._rev = rev
    return rev
}

// ---------------- зеркало _i18n_apply ----------------
function _restore(attr) {
    for (const key of ALL_KEYS) {
        const bk = `${key}_${LANGUAGE_DEFAULT}`
        if (bk in attr) {
            const src = attr[bk]
            delete attr[bk]
            if (src === '') delete attr[key]
            else attr[key] = src
        }
    }
    delete attr[MARK]
}
function _set(attr, key, value) {
    const cur = attr[key]
    if (typeof value !== 'string' || !value || value === cur) return false
    const bk = `${key}_${LANGUAGE_DEFAULT}`
    if (!(bk in attr)) attr[bk] = typeof cur === 'string' ? cur : ''
    attr[key] = value
    return true
}
// один объект: восстановление по пометке → суффиксы → словарь; literal 'node' (узел меню) / 'label' (подпись селектора) — и valueStr
export function applyAttr(attr, ctx, literal = '', dictKeys = I18N_DICT_KEYS) {
    if (!attr || typeof attr !== 'object' || Array.isArray(attr)) return 0
    const { to, T } = ctx
    const c = _ctxOf(attr)   // IE 2026 09 24 / ODOO-341407: контекст словаря ('Frozen|grid')
    const mark = attr[MARK]
    if (mark === to) return 0
    if (mark) _restore(attr)
    let keys = dictKeys
    // IE 2026 10 01 / ODOO-341407: + AttrTab — зеркало бэка attrs.py:267 (группа меню страницы «Rules» после en → uk оставалась английской)
    if (!keys.includes('valueStr') && (literal === 'label' || (literal === 'node' && (attr.attr_type === 'AttrStr' || attr.attr_type === 'AttrTab' || attr.valueStr_fix)))) keys = [...keys, 'valueStr']
    let changed = false
    if (to === LANGUAGE_DEFAULT) {
        for (const key of keys) {
            let text = attr[key]
            if (key === 'valueStr' && !text) text = attr.value
            if (typeof text === 'string' && text && CYR_RE.test(text)) changed = _set(attr, key, T(text, c)) || changed   // IE 2026 09 24 / ODOO-341407: + контекст
        }
    } else {
        for (const key of I18N_KEYS) {
            const v = attr[`${key}_${to}`]
            if (v) changed = _set(attr, key, v) || changed
        }
        for (const key of keys) {
            if (attr[`${key}_${to}`]) continue
            let text = attr[key]
            if (key === 'valueStr' && !text) text = attr.value   // литеральный узел без valueStr — подпись = value
            if (typeof text === 'string' && text) changed = _set(attr, key, T(text, c)) || changed   // IE 2026 09 24 / ODOO-341407: + контекст
        }
    }
    if (changed) attr[MARK] = to
    if (mark || changed) {
        // производные подписи пунктов меню / кнопок (store.prepare_actionMenu: titleAction / titleCommand)
        if (('titleAction' in attr || 'titleCommand' in attr) && ctx.store && typeof ctx.store.prepare_actionMenu === 'function') {
            try { ctx.store.prepare_actionMenu(attr) } catch (e) { /* не пункт меню */ }
        }
        return 1
    }
    return 0
}
function walkAttrs(list, ctx) {
    if (!Array.isArray(list)) return
    for (const attr of list) walkAttr(attr, ctx, '')
}
function walkAttr(attr, ctx, literal) {
    if (!attr || typeof attr !== 'object' || Array.isArray(attr)) return
    if (ctx.seen.has(attr)) return
    ctx.seen.add(attr)
    ctx.n += applyAttr(attr, ctx, literal)
    for (const k of CHILD_LISTS) if (Array.isArray(attr[k])) walkAttrs(attr[k], ctx)
    for (const k of CHILD_DICTS) {
        const child = attr[k]
        if (child && typeof child === 'object' && !Array.isArray(child)) walkAttr(child, ctx, k === 'node' ? 'node' : k === 'leftValue' ? 'label' : '')
    }
    if (attr.groupMenu && typeof attr.groupMenu === 'object') {
        for (const menu of Object.values(attr.groupMenu)) if (Array.isArray(menu)) walkAttrs(menu, ctx)
    }
    // IE 2026 09 24 / ODOO-341407 (проверка dev02: открытая форма параметров вида после живого переключения — значения «All», «Single column»
    // вкладки Params оставались английскими): подписи вариантов itemsSource (не справочник relation_segment) — зеркало бэка localize_attr
    if (Array.isArray(attr.itemsSource) && attr.itemsSource.length && !attr.relation_segment) walkAttrs(attr.itemsSource, ctx)
}
// localize_params_titles: подписи строк doc.params.fieldsMapping — row.attr.title / tooltip, вложенные attrs и attr.source_fieldsMapping
function walkParams(rows, ctx) {
    if (!Array.isArray(rows)) return
    for (const row of rows) {
        if (!row || typeof row !== 'object') continue
        const attr = row.attr
        if (attr && typeof attr === 'object' && !Array.isArray(attr)) {
            if (!ctx.seen.has(attr)) { ctx.seen.add(attr); ctx.n += applyAttr(attr, ctx, '', ['title', 'tooltip']) }
            if (Array.isArray(attr.source_fieldsMapping)) walkParams(attr.source_fieldsMapping, ctx)
        }
        if (Array.isArray(row.attrs)) walkParams(row.attrs, ctx)
    }
}
function _isPredefined(meta) {
    const v = meta && typeof meta === 'object' ? meta.predefined : null
    return v === true || String(v).toLowerCase() === 'true'
}
// record_title_localized: локализованный title записи (meta.title_{lang}, у предопределённой без суффикса — словарь); '' — нет перевода
function titleFor(record, lang, T) {
    if (!record || typeof record !== 'object' || !lang) return ''
    const meta = record.meta && typeof record.meta === 'object' ? record.meta : {}
    const title = record.title
    if (lang === LANGUAGE_DEFAULT) {
        if (typeof title === 'string' && title && CYR_RE.test(title)) { const tr = T(title); return tr !== title ? tr : '' }
        return ''
    }
    const tl = meta[`title_${lang}`]
    if (typeof tl === 'string' && tl) return tl
    if (_isPredefined(meta) && typeof title === 'string' && title) { const tr = T(title); return tr !== title ? tr : '' }
    return ''
}
// localize_record_meta: словарный title_{to} в meta предопределённой записи (пометка _i18n_auto, saveRecord2 его снимает);
// словарный title_{from}, положенный так же, снимается — форма записи как у свежего ответа в новом языке
function localizeRecordMeta(record, from, to, T) {
    const meta = record && typeof record === 'object' && record.meta && typeof record.meta === 'object' ? record.meta : null
    if (!meta) return
    const auto = Array.isArray(meta[AUTO_MARK]) ? meta[AUTO_MARK] : null
    if (auto && from && from !== LANGUAGE_DEFAULT && auto.includes(`title_${from}`)) {
        delete meta[`title_${from}`]
        const rest = auto.filter(k => k !== `title_${from}`)
        if (rest.length) meta[AUTO_MARK] = rest
        else delete meta[AUTO_MARK]
    }
    if (to === LANGUAGE_DEFAULT || !_isPredefined(meta) || meta[`title_${to}`]) return
    const title = record.title
    if (typeof title !== 'string' || !title) return
    const tr = T(title)
    if (tr === title) return
    meta[`title_${to}`] = tr
    const a2 = Array.isArray(meta[AUTO_MARK]) ? meta[AUTO_MARK] : (meta[AUTO_MARK] = [])
    if (!a2.includes(`title_${to}`)) a2.push(`title_${to}`)
}
// строка, переведённая бэком напрямую (без пометки: t() по английскому тексту) → перевод под новым языком; незнакомая — как есть
function _retr(text, ctx) {
    if (typeof text !== 'string' || !text) return text
    const en = ctx.R ? (ctx.R.get(text) ?? text) : text   // обратная карта прежнего языка → английская база (нет в карте — текст и есть база)
    // IE 2026 09 24 / ODOO-341407: обратная карта могла дать ключ с контекстом ('Frozen|grid') — текст + контекст, под en — текст до '|'
    const m = en !== text ? CTX_KEY_RE.exec(en) : null
    return m ? ctx.T(m[1], m[2]) : ctx.T(en)
}
function _retrNotification(text, ctx) {
    if (typeof text !== 'string' || !text) return text
    const m = NOTIFICATION_PREFIX_RE.exec(text)
    if (!m) return _retr(text, ctx)
    return m[1] + _retr(m[2], ctx)
}
// localize_record_menu: «Save Widget» / «Clone Report» — точный ключ, иначе шаблон 'Save {record}' + подпись записи; перевод — суффиксом title_{to}
function recordMenu(items, recordTitleEn, ctx) {
    const { to, T } = ctx
    if (to === LANGUAGE_DEFAULT || !recordTitleEn || !Array.isArray(items)) return
    const recordTr = T(recordTitleEn)
    for (const item of items) {
        if (!item || typeof item !== 'object') continue
        if (item[MARK]) _restore(item)   // база до суффиксов — как у бэка (копии там английские)
        const title = item.title
        if (typeof title === 'string' && title.includes(recordTitleEn) && !item[`title_${to}`] && T(title) === title) {
            const tpl = title.split(recordTitleEn).join('{record}')
            const tplTr = T(tpl)
            if (tplTr !== tpl && recordTr) {
                const word = tplTr.startsWith('{record}') ? recordTr : recordTr.slice(0, 1).toLowerCase() + recordTr.slice(1)
                item[`title_${to}`] = tplTr.split('{record}').join(word)
            }
        }
        if (Array.isArray(item.attrs)) recordMenu(item.attrs, recordTitleEn, ctx)
    }
}

function relocalizeWidget(W, ctx) {
    if (!W || typeof W !== 'object' || W.close) return
    const { from, to, Tfrom, T } = ctx
    const record = W.record && typeof W.record === 'object' ? W.record : null
    // заголовок виджета: WIDGET.title = record.title или его локализация (localize_widget_titles)
    if (record) {
        const base = record.title
        const oldLoc = titleFor(record, from, Tfrom) || base
        localizeRecordMeta(record, from, to, T)
        const newLoc = titleFor(record, to, T) || base
        if (typeof base === 'string' && base && (W.title === oldLoc || W.title === base) && W.title !== newLoc) { W.title = newLoc; ctx.n++ }
        walkParams(record.doc && record.doc.params && record.doc.params.fieldsMapping, ctx)
        // IE 2026 09 24 / ODOO-341407 (проверка dev02, форма строки колонки: после живого переключения на en заголовок колонки оставался
        // словарным украинским): строки-определения полей записи, которые бэк переводит на копии ответа (attrs.localize_record_rows:
        // doc.viewList / view / fields / pages / data_tasks, doc.params.attrs — пометка _i18n + бэкап {key}_en), — то же зеркало
        const doc = record.doc && typeof record.doc === 'object' ? record.doc : null
        if (doc) {
            for (const key of RECORD_ROW_KEYS) walkAttrs(doc[key], ctx)
            if (doc.params && typeof doc.params === 'object') for (const key of RECORD_PARAM_KEYS) walkAttrs(doc.params[key], ctx)
        }
    }
    // подпись записи в пунктах меню («Save Widget») — по английской базе recordTitle ДО его перевода
    const recordTitleEn = ctx.R ? (ctx.R.get(W.recordTitle) ?? W.recordTitle) : W.recordTitle
    for (const key of WIDGET_TITLE_KEYS) {
        if (typeof W[key] === 'string' && W[key]) { const v = _retr(W[key], ctx); if (v !== W[key]) { W[key] = v; ctx.n++ } }
    }
    if (W.groupMenu && typeof W.groupMenu === 'object') {
        for (const menu of Object.values(W.groupMenu)) {
            if (!Array.isArray(menu)) continue
            if (typeof recordTitleEn === 'string' && recordTitleEn) recordMenu(menu, recordTitleEn, ctx)
            walkAttrs(menu, ctx)
        }
    }
    walkAttrs(W.view, ctx)
    if (W.notification && typeof W.notification.text === 'string' && W.notification.text) {
        const v = _retrNotification(W.notification.text, ctx)
        if (v !== W.notification.text) W.notification.text = v
    }
    ctx.widgets++
}

function relocalizeWorkspace(WS, ctx) {
    if (!WS || typeof WS !== 'object') return
    const { from, to, Tfrom, T, store } = ctx   // IE 2026 09 25 / ODOO-341407: + store (заголовок чипса периода)
    const record = WS.record && typeof WS.record === 'object' ? WS.record : null
    if (record) {
        const base = record.title
        const oldLoc = titleFor(record, from, Tfrom) || base
        localizeRecordMeta(record, from, to, T)
        const newLoc = titleFor(record, to, T) || base
        if (typeof base === 'string' && base && (WS.title === oldLoc || WS.title === base) && WS.title !== newLoc) { WS.title = newLoc; ctx.n++ }
        const params = record.doc && record.doc.params
        if (params && typeof params === 'object') {
            walkAttrs(params.WHERE, ctx)          // чипсы стола: подписи селекторов (leftValue.valueStr) и title строк
            walkParams(params.fieldsMapping, ctx)  // панель «Parameters» стола
            // IE 2026 09 25 / ODOO-341407 (находка на dev02 25.09: после переключения без перезагрузки чипс периода в шапке оставался на прежнем языке —
            // «Період» после ухода с uk): title строки периода собирает фронт (store.periodSel_title — t() в момент выбора / открытия стола) и хранит
            // в строке WHERE, чипс шапки показывает его как есть; пересобираем под новый язык из границ периода — значение, use и прочие поля строки
            // не меняются, ничего не сохраняется
            try {
                const row = typeof store.periodSel_row === 'function' ? store.periodSel_row(WS) : null
                const rv = row && row.rightValue
                if (rv && rv.value && typeof store.periodSel_title === 'function') {
                    const tt = store.periodSel_title(rv.value, rv.valueTo)
                    if (tt && tt !== row.title) { row.title = tt; ctx.n++ }
                }
            } catch (e) { console.warn('[i18n] period chip title', e) }
        }
    }
    for (const PAGE of Object.values(WS.PAGES || {})) {
        if (!PAGE || typeof PAGE !== 'object') continue
        walkAttrs(PAGE.attrs, ctx)   // меню страницы (виджеты, 'More', 'User widgets', …)
        const _mm = WS._menuMain?.[PAGE.page]   // IE 2026 10 01 / ODOO-5800: меню варианта страницы — строки основной (store.variantMenu_rows)
        if (_mm && _mm !== PAGE.attrs) walkAttrs(_mm, ctx)
        // группа страниц: title = t(ключ группы) на копии ответа (workspaces.py, PAGE['group'])
        const g = PAGE.group
        if (g && typeof g === 'object' && typeof g.key === 'string' && g.key && !/^group-\d+$/.test(g.key)) {
            const v = T(g.key)
            if (typeof g.title === 'string' && g.title !== v && (g.title === g.key || g.title === Tfrom(g.key) || (ctx.R && ctx.R.has(g.title)))) { g.title = v; ctx.n++ }
        }
        if (PAGE.notification && typeof PAGE.notification.text === 'string' && PAGE.notification.text) {
            const v = _retrNotification(PAGE.notification.text, ctx)
            if (v !== PAGE.notification.text) PAGE.notification.text = v
        }
    }
    if (WS.notification && typeof WS.notification.text === 'string' && WS.notification.text) {
        const v = _retrNotification(WS.notification.text, ctx)
        if (v !== WS.notification.text) WS.notification.text = v
    }
    for (const W of WS.ALL_WIDGETS || []) { try { relocalizeWidget(W, ctx) } catch (e) { console.warn('[i18n] widget', W && W.id, e) } }
}

// IE 2026 09 24 / ODOO-341407 (проверка dev02: форма строки, открытая до живого переключения, — шапка «Row[1]» и заголовок «З країн::_doc.data»
// оставались прежними): открытые попапы widget-row — служебная шапка заново (store.set_widgetRow_shortTitle: t('Row') + номер / путь каскада,
// t('View'), чипс) и заголовок формы строки «<заголовок виджета-родителя>::<биндинг>» (store widget_open) — от заголовка родителя в новом
// языке (проход подписей его уже перевёл); заголовок, не похожий на собранный так (другой тип попапа, правка), не трогаем.
// Родитель раньше потомка: путь каскада Row→Row берётся у родителя
function relabelRowForms(store, ctx) {
    if (!store || typeof store.set_widgetRow_shortTitle !== 'function') return
    const rows = []
    for (const WS of Object.values(store.WORKSPACES || {})) for (const W of (WS && WS.ALL_WIDGETS) || []) if (W && !W.close && W.widget === 'widget-row') rows.push(W)
    if (!rows.length) return
    const find = (id) => { try { return store.findWidget(id)?.WIDGET || null } catch (e) { return null } }
    const depth = (W) => { let d = 0, p = W.parentWIDGET; while (p && d < 10) { const P = find(p.id); if (!P || P.widget !== 'widget-row') break; d++; p = P.parentWIDGET } return d }
    rows.sort((a, b) => depth(a) - depth(b))
    for (const W of rows) {
        const meta = W.record && W.record._meta
        if (!meta || typeof meta !== 'object') continue
        try { const was = W.shortTitle; store.set_widgetRow_shortTitle(W, meta); if (W.shortTitle !== was) ctx.n++ } catch (e) { console.warn('[i18n] row form header', W.id, e) }
        if ((meta.type || 'widget-row') !== 'widget-row' || typeof meta.binding !== 'string' || !meta.binding) continue
        const tail = '::' + meta.binding
        if (typeof W.title !== 'string' || !W.title.endsWith(tail)) continue
        const P = W.parentWIDGET && find(W.parentWIDGET.id)
        if (P && typeof P.title === 'string' && P.title && W.title !== P.title + tail) { W.title = P.title + tail; ctx.n++ }
    }
}

// «Refresh data» отчётов активной страницы без несохранённых правок: подписи в данных (месяцы / итоги / меры DL2) ставит бэк
// IE 2026 09 24 / ODOO-341407 (проверка dev02: вернулся на страницу, открытую до переключения, — строки данных отчёта («Sales», «Actual»,
// «⚠ Uncovered (auto-planned)») остались на прежнем языке до ручного обновления; меры по справочнику переподписывались, литералы данных — нет):
// отчёты ОСТАЛЬНЫХ открытых страниц (KeepAlive, в т.ч. других столов) помечаются _i18n_refresh_needed = {from, to} и перезапрашиваются при
// активации своей страницы (i18nRefreshOnActivate из workspace_activate) по тому же правилу; тот же выключатель fe.i18n.switchRefreshData
// IE 2026 09 24 / ODOO-341407 (проверка dev02: Гант движений 585_001-gantt-moves — СПИСОК WIDGET-LIST, не отчёт — после живого переключения
// держал прежние названия слоёв (attr.measure_titles с бэка) даже на активной странице): перезапрос — у ВИДЖЕТОВ ДАННЫХ, чей select («Update
// data») приносит подписи, переведённые бэком под язык запроса: отчёты (строки DL2, литералы раскладки, календарные заголовки) и списки
// widget_LIST (колонки грида из doc.viewList — localize_attrs в _select_impl, названия записей meta.title_{lang}, вкладки Gantt (measure_titles),
// Chart, Geo map, Metrics). Не перезапрашиваются: WIDGET-TREE (select отдаёт title как в базе — перевода нет и при свежем открытии), журналы
// (select_log: заголовки колонок — в view, их ведёт проход подписей; статусы — справочник STATUS, проход по id), формы записей и панель задач стола
// (проход подписей + проход по id), селекторы; pivot (widget_report_select без перевода). REPORT_BASIC / REPORT_list — в прежнем правиле /REPORT/
const NO_DATA_WIDGETS = ['widget-selectors', 'widget-row', 'widget-record', 'widget-raw-record']   // формы и селекторы — не виджеты данных, даже при классе / сегменте записи отчёта / списка
const _dataKind = (W) => {
    if (NO_DATA_WIDGETS.includes(W.widget)) return ''
    const wc = String(W.widget_class || (W.record && W.record.segment) || W.widget || '')
    if (/REPORT/.test(wc)) return 'report'
    if (wc === 'widget_LIST' || wc === 'WIDGET-LIST') return 'list'
    return ''
}
// IE 2026 09 24 / ODOO-341407: несохранённые правки = запись изменена ИЛИ правленные рукой ячейки грида (жёлтые): правка отчёта (_doc.data)
// record._meta.modified не ставит — select упирался в гард несохранённого и вместо «только переподписать» показывал диалог на виджете
// IE 2026 09 24 / ODOO-341407 (списки): ещё — основной грид «изменён» (AttrGrid.modified: правка, вставка, удалённая строка до Save или отката —
// deletedItems; откат Ctrl+Z его снимает), строки данных с пометкой новой (_meta.new) и открытые дочерние формы с несохранённым (форма записи /
// строки: запись изменена или правленые ячейки её гридов). Правка через форму строки (widget-row) пишется в undo-стек грида списка (attr_set:
// «Edit … (row card)») — её ловят corrections; открытую форму строки и без правок держит _openRowForm ниже (select её закрыл бы).
// _meta.modified строки — НЕ признак: замер dev02 24.09 (BYb_001, правка ячейки → Ctrl+Z) — значение вернулось, грид «не изменён», а пометка
// строки осталась. Отчёты — прежнее правило несохранённого (проверено живьём 24.09) + открытая форма строки
const DIRTY_ROWS_MAX = 20000
function _grid(W) {
    try {
        const vo = W.vueObj
        if (!vo || typeof vo.get_vueObj !== 'function') return null
        for (const name of ['dataSheet', '_doc.data']) { const g = vo.get_vueObj(name); if (g && typeof g.corrChip_cells === 'function') return g }
    } catch (e) { /* виджет без грида данных */ }
    return null
}
function _rowsDirty(rows, seen = { n: 0 }, depth = 0) {
    if (!Array.isArray(rows) || depth > 8) return false
    for (const r of rows) {
        if (!r || typeof r !== 'object') continue
        if (++seen.n > DIRTY_ROWS_MAX) return false
        const m = r._meta
        if (m && typeof m === 'object' && m.new) return true
        if (Array.isArray(r.attrs) && r.attrs.length && _rowsDirty(r.attrs, seen, depth + 1)) return true
    }
    return false
}
function _dirtyForm(store, C) {
    if (C.record && C.record._meta && C.record._meta.modified) return true
    try { return typeof store.unsavedGuard_dirtyInfo === 'function' && !!store.unsavedGuard_dirtyInfo(C) } catch (e) { return false }
}
function _openForm(store, W) {
    const ws = store.WORKSPACES && store.WORKSPACES[W.workspace]
    for (const C of (ws && ws.ALL_WIDGETS) || []) {
        if (!C || C === W || C.close || C.page !== W.page || !C.parentWIDGET || C.parentWIDGET.id !== W.id) continue
        if (NO_DATA_WIDGETS.includes(C.widget) && C.widget !== 'widget-selectors' && _dirtyForm(store, C)) return true
    }
    return false
}
// IE 2026 09 25 / ODOO-341407 (замер dev02 25.09: клик по свёртке группы колонок Sales$ / 1fxa_001 ставит record._meta.modified — запись «изменена»
// состоянием вида): relaxed (флаг switchRefreshModified) — как штатный гард select (mainStore.unsavedGuard_check: «обновление данных запись не
// трогает, спрашиваем только про правки ДАННЫХ»): изменённые настройки / вид не держат виджет на прежнем языке, держат только правленые ячейки
// (corrections) и несохранённое списка ниже. Раньше такой отчёт после переключения оставался со строками данных на прежнем языке, а при первом
// же обновлении колонок терял раскрытые группы (ключи свёртки — по заголовкам прежнего языка; см. AttrGrid.foldGroups_paths)
function _hasUnsaved(store, W, relaxed = false) {
    if (!relaxed && W.record && W.record._meta && W.record._meta.modified) return true
    try {
        const info = typeof store.unsavedGuard_dirtyInfo === 'function' ? store.unsavedGuard_dirtyInfo(W) : null
        if (info && (!relaxed || info.cells)) return true
    } catch (e) { /* как без правок */ }
    if (_dataKind(W) !== 'list') return false
    const g = _grid(W)
    if (g && (g.modified || (Array.isArray(g.deletedItems) && g.deletedItems.length))) return true
    if (_rowsDirty(W.record && W.record._doc && W.record._doc.data)) return true
    return _openForm(store, W)
}
// IE 2026 09 24 / ODOO-341407 (замер dev02 24.09: BYb_001, «Open line» Alt+F2 → «Update data» — открытая форма строки исчезла; стек —
// WidgetAttrs.content_Changed → close_childrenWidgets(WIDGET, 'widget-row', 'widget-row-viewParams') на каждом обновлении данных): у виджета
// данных (отчёт / список) с ОТКРЫТОЙ формой строки / ячейки (widget-row, не скрытой Esc, кроме настроек грида widget-row-viewParams) select
// закрыл бы её — «не терялось открытое» (поручение Игоря): такой виджет только переподписывается, данные — при следующем обновлении (уведомление)
function _openRowForm(store, W) {
    const ws = store.WORKSPACES && store.WORKSPACES[W.workspace]
    for (const C of (ws && ws.ALL_WIDGETS) || []) {
        if (!C || C === W || C.close || C._softClosed || C.widget !== 'widget-row' || C.page !== W.page || !C.parentWIDGET || C.parentWIDGET.id !== W.id) continue
        if (C.record && C.record._meta && C.record._meta.type === 'widget-row-viewParams') continue
        return true
    }
    return false
}
// причина не перезапрашивать: 'unsaved' — несохранённые правки, 'form' — открытая форма строки; '' — select
function _keepReason(store, W, relaxed = false) {   // IE 2026 09 25 / ODOO-341407: + relaxed (флаг switchRefreshModified)
    if (_hasUnsaved(store, W, relaxed)) return 'unsaved'
    if (_openRowForm(store, W)) return 'form'
    return ''
}
// запрос данных виджета в полёте (select / widget_open / повтор open)
const _busy = (W) => !!(W.loading || (W._openRequest && W._openRequest.readyState !== 4) || (W._activeRequest && W._activeRequest.readyState !== 4))

// ---------------- IE 2026 09 25 / ODOO-341407 (замечание пользователей: «не всегда понятно, когда переключение выполнено полностью, включая
// обновление выведенных элементов»): ход переключения — индикатор I18nSwitchProgress.vue (App.vue) по реактивному switchProgress ----------------
// Завершение = завершены ВСЕ перезапросы данных активной страницы (отслеживаются виджеты, которым ушёл select: запрос виден в полёте → закончился;
// ошибка — notification виджета status 'error'), проход подписей и словари, используемые на странице. Виджеты других страниц — счётчиком «обновятся
// при открытии» (там индикатор ведёт активация страницы, mode 'activation'). Флаг switchProgress (выкл — прежний тост про оставленные виджеты)
export const switchProgress = reactive({
    visible: false, active: false, mode: 'switch', lang: '', langTitle: '', total: 0, done: 0, failed: 0, failedTitles: [],
    kept: 0, keptForm: 0, otherPages: 0, hidden: 0, dictsBusy: false, phase: '', ms: 0, error: '', stillLoading: 0, seq: 0,
})
const PROGRESS_POLL_MS = 250, PROGRESS_MAX_MS = 180000, PROGRESS_UNSEEN_MS = 3000
let _prog = null, _hideTimer = null, _lastRun = null
const _langTitle = (id) => { const l = LANGUAGES.find(x => x.id === id); return l ? l.title : id }
function progressBegin(store, { to, t0 = 0, mode = 'switch', on = true } = {}) {
    if (_prog && _prog.timer) clearInterval(_prog.timer)
    if (_prog) _wakeWaiters(_prog)   // прежний ход вытеснен — его ожидающие не должны висеть
    if (_hideTimer) { clearTimeout(_hideTimer); _hideTimer = null }
    const seq = (switchProgress.seq || 0) + 1
    _prog = { seq, t0: t0 || performance.now(), items: [], walkDone: false, dicts: false, on, mode, lang: to, store, info: null, onDone: [], waiters: [] }
    Object.assign(switchProgress, { visible: !!on, active: true, mode, lang: to, langTitle: _langTitle(to), total: 0, done: 0, failed: 0, failedTitles: [],
        kept: 0, keptForm: 0, otherPages: 0, hidden: 0, dictsBusy: false, phase: mode === 'activation' ? 'data' : 'ui', ms: 0, error: '', stillLoading: 0, seq })
    const P = _prog
    P.timer = setInterval(() => _progressTick(P), PROGRESS_POLL_MS)
    return P
}
function progressTrack(P, W) {
    if (!P || !W) return
    P.items.push({ W, seen: _busy(W), done: false, failed: false, t0: performance.now(), t1: 0, rid: (W.record && W.record.id) || W.id, title: W.title || '' })
    if (P === _prog) switchProgress.total = P.items.length
}
function _progressTick(P) {
    if (P !== _prog) { clearInterval(P.timer); return }
    const now = performance.now()
    let done = 0, failed = 0
    for (const it of P.items) {
        if (!it.done) {
            const busy = !it.W.close && _busy(it.W)
            if (busy) it.seen = true
            else if (it.seen || it.W.close || now - it.t0 > PROGRESS_UNSEEN_MS) {
                it.done = true; it.t1 = now
                const n = it.W.notification
                it.failed = !it.W.close && !!(n && n.status === 'error')
                if (it.failed) it.error = String(n.text || '').slice(0, 200)
            }
        }
        if (it.done) { done++; if (it.failed) failed++ }
    }
    switchProgress.done = done
    switchProgress.failed = failed
    if (failed) switchProgress.failedTitles = P.items.filter(i => i.failed).map(i => (!i.W.close && i.W.title) || i.title || String(i.rid)).slice(0, 5)   // заголовок — текущий (на новом языке), не снимок до прохода подписей
    if (done >= P.items.length) _wakeWaiters(P)   // IE 2026 09 25 / ODOO-341407: switchDictsAfterData — словари ждут данные страницы
    switchProgress.dictsBusy = !!P.dicts
    switchProgress.phase = !P.walkDone ? (switchProgress.phase === 'ui' ? 'ui' : 'labels') : (done < P.items.length ? 'data' : (P.dicts ? 'dicts' : 'done'))
    const complete = P.walkDone && !P.dicts && done >= P.items.length
    if (complete || now - P.t0 > PROGRESS_MAX_MS) _progressFinish(P, !complete)
}
function _wakeWaiters(P) {
    const w = P.waiters || []
    P.waiters = []
    for (const fn of w) { try { fn() } catch (e) { /* ожидающий уже не ждёт */ } }
}
// IE 2026 09 25 / ODOO-341407: все отслеживаемые виджеты данных закончили (или ход вытеснен / завершён; не дольше maxMs)
function progressWidgetsDone(P, maxMs = 60000) {
    if (!P || P !== _prog || !P.timer || P.items.every(i => i.done)) return Promise.resolve()
    return new Promise((resolve) => { P.waiters.push(resolve); setTimeout(resolve, maxMs) })
}
function _progressFinish(P, timedOut) {
    clearInterval(P.timer); P.timer = null
    _wakeWaiters(P)
    const now = performance.now()
    const ms = Math.round(now - P.t0)
    const w = P.items.map(i => ({ rid: i.rid, ms: i.t1 ? Math.round(i.t1 - P.t0) : null, failed: i.failed || undefined, error: i.error || undefined }))
    const info = P.info || {}
    _lastRun = { lang: P.lang, mode: P.mode, totalMs: ms, timedOut: !!timedOut, t: { ...(info.t || {}) }, dictMs: info.dictMs, walkMs: info.walkMs, attrs: info.attrs,
        widgets: w, refreshed: info.refreshed, kept: info.kept, keptForm: info.keptForm, otherPages: info.otherPages, noRepeat: (P.store && P.store._i18nNoRepeat) || 0,
        dicts: { asked: info.dataSegments, refreshed: info.dataRefreshed, background: info.dataBackground, waitMs: info.dataWaitMs, coalesced: info.dataCoalesced },
        flags: P.store ? _flags(P.store) : null, at: Date.now() }
    Object.assign(switchProgress, { active: false, ms, stillLoading: timedOut ? P.items.filter(i => !i.done).length : 0, phase: 'done', dictsBusy: false })
    const slow = w.filter(x => x.ms !== null).sort((a, b) => b.ms - a.ms)[0]
    console.log(`[i18n] ${P.mode === 'activation' ? 'page activation' : 'switch'} to ${P.lang} complete in ${ms} ms${P.mode === 'switch' ? ` (ui ${_lastRun.t.ui ?? '?'} ms, dictionaries ready ${_lastRun.t.dict ?? '?'} ms, labels ${_lastRun.t.attrs ?? '?'} ms, data requests sent ${_lastRun.t.sent ?? '?'} ms)` : ''}: ${w.length} data widgets${slow ? `, slowest ${slow.rid} ${slow.ms} ms` : ''}${switchProgress.failed ? `, ${switchProgress.failed} failed` : ''}${timedOut ? `, ${switchProgress.stillLoading} still loading` : ''}${_lastRun.noRepeat ? `, stale-language cache keys dropped so far: ${_lastRun.noRepeat}` : ''}`)
    const hideMs = (switchProgress.failed || switchProgress.error || timedOut) ? 20000 : 6000
    _hideTimer = setTimeout(() => { if (switchProgress.seq === P.seq) switchProgress.visible = false }, hideMs)
    for (const fn of P.onDone) { try { fn() } catch (e) { console.warn('[i18n] after switch', e) } }
}
export function switchProgressHide() { if (_hideTimer) { clearTimeout(_hideTimer); _hideTimer = null } switchProgress.visible = false }
// IE 2026 09 24 / ODOO-341407: тост один (store.notification — следующий info заменяет предыдущий): обе причины — одним сообщением
function _notifyKept(store, n, nForm = 0) {
    if (switchProgress.visible) return   // IE 2026 09 25 / ODOO-341407: индикатор хода переключения показывает оставленные виджеты сам
    let text = ''
    if (n && nForm) text = tnFe(n + nForm, '{n} widget keeps unsaved edits or an open row form — its data labels update on the next refresh', '{n} widgets keep unsaved edits or open row forms — their data labels update on the next refresh')
    else if (n) text = tnFe(n, '{n} widget keeps unsaved edits — its data labels update on the next refresh', '{n} widgets keep unsaved edits — their data labels update on the next refresh')
    else if (nForm) text = tnFe(nForm, '{n} widget with an open row form was not refreshed — its data labels update on the next refresh', '{n} widgets with open row forms were not refreshed — their data labels update on the next refresh')
    if (!text) return
    try { store.TERMINAL(null, null, { text, status: 'info' }) } catch (e) { /* без панели уведомлений */ }
}
// IE 2026 09 24 / ODOO-341407: счётчики по видам (report / list) — замер «сколько чего перезапрошено» рядом с выключателем
const _count = (out, key, kind) => { out[key]++; const k = out.byKind[kind] || (out.byKind[kind] = {}); k[key] = (k[key] || 0) + 1 }
const _kinds = (byKind) => Object.entries(byKind || {}).map(([k, v]) => `${k} ${Object.entries(v).map(([a, n]) => `${a} ${n}`).join('/')}`).join('; ')
function refreshDataWidgets(store, ctx, P = null, flags = null) {   // IE 2026 09 24 / ODOO-341407: было refreshReports — теперь отчёты и списки (_dataKind); IE 2026 09 25: + P (ход переключения), flags
    const WS = store.activeWORKSPACE
    const out = { refreshed: 0, kept: 0, keptForm: 0, otherPages: 0, hidden: 0, byKind: {} }
    const relaxed = !!(flags && flags.switchRefreshModified)   // IE 2026 09 25 / ODOO-341407
    for (const ws of Object.values(store.WORKSPACES || {})) {
        if (!ws || typeof ws !== 'object') continue
        for (const W of ws.ALL_WIDGETS || []) {
            if (!W || W.close || !W.vueObj) continue
            const kind = _dataKind(W)
            if (!kind) continue
            if (ws !== WS || W.page !== WS.active_page) {
                // язык, на котором построены данные, — от первой пометки (en → uk → en: данные уже английские, перезапрос не нужен)
                const f = W._i18n_refresh_needed
                if (f && typeof f === 'object') f.to = ctx.to
                else W._i18n_refresh_needed = { from: ctx.from, to: ctx.to }
                _count(out, 'otherPages', kind)
                continue
            }
            const keep = _keepReason(store, W, relaxed)   // IE 2026 09 24 / ODOO-341407: несохранённое / открытая форма строки
            if (keep) { _count(out, keep === 'form' ? 'keptForm' : 'kept', kind); continue }
            // IE 2026 09 24 / ODOO-341407: скрытый (Esc) на активной странице — как при активации: select при восстановлении (_widget_restoreSoftClosed)
            if (W._softClosed) { W._selector_refresh_needed = true; _count(out, 'hidden', kind); continue }
            try {
                store.executeStoreMethod(W.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })
                _count(out, 'refreshed', kind)
                progressTrack(P, W)   // IE 2026 09 25 / ODOO-341407: индикатор — «N из M виджетов обновлено»
            } catch (e) { console.warn('[i18n] refresh', W.id, e) }
        }
    }
    if (P) Object.assign(switchProgress, { kept: out.kept, keptForm: out.keptForm, otherPages: out.otherPages, hidden: out.hidden })   // IE 2026 09 25 / ODOO-341407
    _notifyKept(store, out.kept, out.keptForm)
    return out
}

// IE 2026 09 24 / ODOO-341407: активация страницы (workspace_activate). До штатных обработчиков (pageFocus — повтор остановленных open,
// updateRelatedWidgets по чипсам / refresh_needed, смена модели, период) — i18nPendingOnActivate: помеченные отчёты страницы и кто из них уже
// грузился (запрос ушёл на прежнем языке). После — i18nRefreshOnActivate: select тем, у кого нет несохранённых правок и кого активация сама не
// перезапросила (новый запрос уже на новом языке — второй не шлём); с правками — только переподписаны (проход подписей шёл по всем виджетам),
// данные ждут следующего обновления (уведомление); скрытый (Esc) — перечитается при восстановлении; язык вернулся к языку данных — пометка снимается
export function i18nPendingOnActivate(widgets) {
    const out = []
    for (const W of widgets || []) if (W && W._i18n_refresh_needed) out.push({ W, busy: _busy(W) })
    return out
}
export function i18nRefreshOnActivate(store, pending) {
    const out = { refreshed: 0, kept: 0, keptForm: 0, fresh: 0, same: 0, hidden: 0, byKind: {} }
    if (!Array.isArray(pending) || !pending.length) return out
    const on = store.setting('fe.i18n.switchRefreshData', true) !== false
    const lang = getLanguage()
    const flags = _flags(store)   // IE 2026 09 25 / ODOO-341407: relaxed-гард (switchRefreshModified), индикатор (switchProgress)
    let P = null
    for (const { W, busy } of pending) {
        const f = W && W._i18n_refresh_needed
        if (!f) continue
        if (W.close) { delete W._i18n_refresh_needed; continue }
        if (!W.vueObj) continue   // не смонтирован — пометка ждёт монтирования
        delete W._i18n_refresh_needed
        if (!on) continue
        const kind = _dataKind(W) || 'other'   // IE 2026 09 24 / ODOO-341407: отчёт / список
        if (f.from === lang) { _count(out, 'same', kind); continue }
        if (!busy && _busy(W)) { _count(out, 'fresh', kind); continue }
        // IE 2026 09 24 / ODOO-341407: несохранённое — раньше скрытого: скрытый с правками не получает select при восстановлении (там был бы диалог)
        const keep = _keepReason(store, W, flags.switchRefreshModified)
        if (keep) { _count(out, keep === 'form' ? 'keptForm' : 'kept', kind); continue }
        if (W._softClosed) { W._selector_refresh_needed = true; _count(out, 'hidden', kind); continue }   // _widget_restoreSoftClosed: select при восстановлении
        try {
            store.executeStoreMethod(W.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })
            _count(out, 'refreshed', kind)
            // IE 2026 09 25 / ODOO-341407: индикатор — страница, открытая после переключения, дообновляется («Updating the page…», N из M)
            if (!P && flags.switchProgress) { P = progressBegin(store, { to: lang, mode: 'activation', on: true }); P.walkDone = true }
            progressTrack(P, W)
        } catch (e) { console.warn('[i18n] refresh on activation', W.id, e) }
    }
    if (P) Object.assign(switchProgress, { kept: out.kept, keptForm: out.keptForm, hidden: out.hidden })
    _notifyKept(store, out.kept, out.keptForm)
    console.log(`[i18n] page activated under ${lang}: ${out.refreshed} data widgets refreshed, ${out.kept} with unsaved edits kept, ${out.keptForm} with an open row form kept, ${out.fresh} already re-requested by the activation, ${out.same} data already in ${lang}, ${out.hidden} hidden (refresh on restore)${out.refreshed + out.kept + out.keptForm + out.fresh + out.same + out.hidden ? ` [${_kinds(out.byKind)}]` : ''}`)   // IE 2026 09 24 / ODOO-341407: отчёты и списки, по видам
    return out
}

// ---------------- IE 2026 09 24 / ODOO-341407 (второй обход dev02: после живого переключения рейка столов, панель страниц и загруженные
// данные оставались английскими — 69 строк, после перезагрузки страницы 0) ----
// Подписи ЗАПИСЕЙ по id в новом языке: рейка столов (menuTree: узлы-ссылки столов), панель страниц (PAGES[*].node, строки doc.pages стола),
// дерево настроек (WIDGET.parents_tree / variants_tree), строки гридов записи (doc.* / _doc.*: словари node / attr / leftValue / rightValue
// со ссылкой; литеральные — по словарю; строки-записи с meta — словарный meta.title_{lang} у предопределённой, колонка translate читает его
// при перерисовке) и справочники itemsSource (dataMap ссылочных колонок). Источник подписи — тот же get_itemsSource, что резолвит ссылки
// (бэк: COALESCE(meta.title_{lang}, title), словарь у предопределённой, кэш per-lang): id собираем по сегментам, ставим by_ids в штатную
// очередь стора (+ refresh уже закэшированных справочников до DATA_REFRESH_MAX id), ждём опустошения очереди и раздаём titles по узлам;
// затем phase 'data' (гриды — invalidate, панель настроек — пересборка списка, модель рейла — заново). Открытый стол — сразу из
// WORKSPACES[id].record (meta.title_{lang} → словарь → база). Выключатель fe.i18n.switchRelabelData (по умолчанию вкл.)
const DATA_REFRESH_MAX = 3000
// справочник SEGMENTS через штатный refresh НЕ перечитываем: замер dev02 24.09 (tools/i18n_refresh_bisect.mjs) — его подмена зацикливает
// AttrChips (_resolveChipValues ↔ chips deep-watcher, «Maximum recursive updates exceeded»), остальные 40 справочников — чисто;
// названия сегментов в строках ({value: 'DATA-SOURCE', valueStr: 'Data sources'}) идут по словарю
const DATA_REFRESH_SKIP = ['SEGMENTS']
const DATA_ROWS_MAX = 5000
const GRID_TYPES = ['AttrGrid', 'AttrTabGrid', 'AttrGridGroup', 'AttrTree', 'AttrTabGridLanes']
const ROW_DICTS = ['node', 'attr', 'leftValue', 'rightValue']
const PARAMS_BINDINGS = ['doc.params.WHERE', 'doc.params.fieldsMapping']   // их ведёт проход подписей (walkAttrs / walkParams)
const _idOk = (id) => typeof id === 'string' && !!id && !id.startsWith('=') && !id.startsWith('#') && !id.startsWith('<')

function _need(ctx, seg, id, apply) {
    if (!seg || typeof seg !== 'string' || !_idOk(id)) return
    ;(ctx.bySeg[seg] = ctx.bySeg[seg] || new Set()).add(id)
    ctx.targets.push({ seg, id, apply })
}
// запись подписи: в данных записи (строки гридов, doc.pages стола) — с бэкапом {key}_en и пометкой _i18n, как localize_attr бэка
// (перед сохранением служебные ключи снимаются, база остаётся английской); во временных структурах (menuTree, PAGES, parents_tree) — как есть
function _put(obj, key, value, ctx, marked) {
    if (typeof value !== 'string' || !value || obj[key] === value) return false
    if (!marked) { obj[key] = value; ctx.n++; return true }
    if (_set(obj, key, value)) { obj[MARK] = ctx.to; ctx.n++; return true }
    return false
}
// узел-ссылка {value, valueStr, attr_type: 'AttrLink', relation_segment}: подпись записи по id; открытый стол — сразу по его записи
function _needLink(ctx, node, store, marked = false) {
    if (!node || typeof node !== 'object' || node.attr_type !== 'AttrLink' || !node.relation_segment || !_idOk(node.value)) return false
    const ws = store.WORKSPACES && store.WORKSPACES[node.value]
    const rec = ws && ws.record && typeof ws.record === 'object' ? ws.record : null
    if (rec && rec.id === node.value) _put(node, 'valueStr', titleFor(rec, ctx.to, ctx.T) || rec.title, ctx, marked)
    _need(ctx, node.relation_segment, node.value, (title) => _put(node, 'valueStr', title, ctx, marked))
    return true
}
function collectMenu(nodes, ctx, store, depth = 0) {
    if (!Array.isArray(nodes) || depth > 8) return
    for (const n of nodes) {
        if (!n || typeof n !== 'object') continue
        _needLink(ctx, n.node, store)
        collectMenu(n.attrs, ctx, store, depth + 1)
    }
}
// IE 2026 10 01 / ODOO-341407 (отчёт ie-demo7 / Андрея, Demo 6 dev02: после uk→en пункты-виджеты меню страницы — «Продажі», «Продукти» —
// оставались украинскими, хотя в базе названия английские): PAGE.attrs — меню страницы (AppTopbar читает node.valueStr), пункты-виджеты —
// узлы-ссылки {attr_type: 'AttrLink', relation_segment: 'WIDGET-LIST', value: id}. Проход подписей (walkAttrs) ссылку по словарю не
// переводит, а подпись на прежнем языке словарю не известна — берём название виджета по id в новом языке (как узлы menuTree и PAGE.node)
export function collectPageLinks(WS, ctx, store) {
    for (const PAGE of Object.values((WS && WS.PAGES) || {})) {
        if (!PAGE || typeof PAGE !== 'object') continue
        _needLink(ctx, PAGE.node, store)
        collectMenu(PAGE.attrs, ctx, store)
    }
}
// строки гридов записи (и группы страниц doc.pages): ссылки — по id; литеральные словари ({value, valueStr}, value ≠ valueStr) — сегмент
// по справочнику SEGMENTS, иначе словарь; объекты, уже переведённые проходом подписей (_i18n / valueStr_en), не трогаем
function collectRows(rows, ctx, store, depth = 0) {
    if (!Array.isArray(rows) || depth > 8) return
    let i = 0
    for (const row of rows) {
        if (!row || typeof row !== 'object' || ctx.seen.has(row)) continue
        if (i++ > DATA_ROWS_MAX) break
        ctx.seen.add(row)
        if (row.meta && typeof row.meta === 'object' && typeof row.title === 'string') localizeRecordMeta(row, ctx.from, ctx.to, ctx.T)
        for (const k of ROW_DICTS) {
            const d = row[k]
            if (!d || typeof d !== 'object' || Array.isArray(d)) continue
            if (d[MARK]) { if (d[MARK] === ctx.to) continue; _restore(d) }   // переведено ранее (проход подписей / прошлое переключение) — от английской базы
            if (_needLink(ctx, d, store, true)) continue
            if (typeof d.valueStr !== 'string' || !d.valueStr || typeof d.value !== 'string' || d.value === d.valueStr) continue
            _put(d, 'valueStr', ctx.T(d.valueStr), ctx, true)   // литерал ({value: 'DATA-SOURCE', valueStr: 'Data sources'}) — словарь от базы
        }
        if (Array.isArray(row.attrs)) collectRows(row.attrs, ctx, store, depth + 1)
    }
}
function gridBindings(attrs, out, depth = 0) {
    if (!Array.isArray(attrs) || depth > 8) return out
    for (const a of attrs) {
        if (!a || typeof a !== 'object') continue
        if (GRID_TYPES.includes(a.attr_type) && typeof a.binding === 'string' && a.binding && !PARAMS_BINDINGS.includes(a.binding)) out.add(a.binding)
        gridBindings(a.attrs, out, depth + 1)
    }
    return out
}
function collectTree(nodes, ctx, depth = 0) {   // WIDGET.parents_tree / variants_tree: {id, segment, title, attrs}
    if (!Array.isArray(nodes) || depth > 12) return
    for (const n of nodes) {
        if (!n || typeof n !== 'object') continue
        _need(ctx, n.segment, n.id, (title) => { if (n.title !== title) { n.title = title; ctx.n++ } })
        collectTree(n.attrs, ctx, depth + 1)
    }
}
function collectWidget(W, ctx, store) {
    if (!W || typeof W !== 'object' || W.close) return
    collectTree(W.parents_tree, ctx)
    collectTree(W.variants_tree, ctx)
    const record = W.record && typeof W.record === 'object' ? W.record : null
    if (!record) return
    for (const binding of gridBindings(W.view, new Set())) {
        let rows = null
        try { rows = store.get_value(record, binding) } catch (e) { rows = null }
        collectRows(rows, ctx, store)
    }
}
// ждём, пока очередь get_itemsSource стора (by_ids уходит через 50 мс, не больше 3 активных) опустеет
function _awaitItemsSources(store, timeout = 20000) {
    const t0 = performance.now()
    return new Promise((resolve) => {
        const tick = () => {
            const active = Object.keys(store._itemsSource_active || {}).length, queued = Object.keys(store._itemsSource_queue || {}).length
            if ((!active && !queued) || performance.now() - t0 > timeout) return resolve(Math.round(performance.now() - t0))
            setTimeout(tick, 100)
        }
        setTimeout(tick, 120)
    })
}
// IE 2026 09 25 / ODOO-341407 (замер dev02 25.09, страница 1EiJ_001: фаза подписей по id — 46–48 запросов get_itemsSource по 3 одновременно, 11–20 с,
// в очереди бэка за тяжёлыми select'ами; каждый ответ словаря — отдельная перерисовка гридов (flexRefresh ≈1,3 с CPU за переключение)):
// словари, НЕ используемые на активной странице (не колонки её смонтированных гридов, не чипсы стола, не подписи по id), перечитываются
// в фоне ПОСЛЕ завершения переключения (switchDictsScoped); на время перечитывания пересборка dataMap не будит гриды по каждому словарю —
// одна волна на все (switchDictsCoalesce, store.get_dataMap + itemsSource_bump)
function _usedSegments(store) {
    const out = new Set()
    const add = (seg) => { if (typeof seg === 'string' && seg && !seg.startsWith('=')) out.add(seg) }
    const WS = store.activeWORKSPACE
    if (!WS) return out
    const pg = WS.active_page
    const where = (WS.record && WS.record.doc && WS.record.doc.params && WS.record.doc.params.WHERE) || []
    const walkWhere = (rows, d) => {
        for (const r of rows || []) {
            if (!r || typeof r !== 'object') continue
            add(r.rightValue && r.rightValue.relation_segment)
            if (d < 4 && Array.isArray(r.attrs)) walkWhere(r.attrs, d + 1)
        }
    }
    walkWhere(where, 0)
    for (const W of WS.ALL_WIDGETS || []) {
        if (!W || W.close || W.page !== pg) continue
        for (const vo of Object.values(W.attrs_vueObj || {})) {
            if (!vo || typeof vo !== 'object') continue
            try {
                add(vo.attr && vo.attr.relation_segment)
                const abb = vo.attr_by_binding
                if (abb && vo.flex && Array.isArray(vo.flex.columns)) {
                    for (const col of vo.flex.columns) {
                        const ac = abb[col.binding]
                        if (!ac) continue
                        add(ac.relation_segment)
                        if (Array.isArray(ac.attrs)) for (const x of ac.attrs) add(x && x.relation_segment)
                    }
                }
                if (vo._segBinding_segments) for (const sg of vo._segBinding_segments) add(sg)
            } catch (e) { /* компонент пересоздаётся */ }
        }
    }
    return out
}
function _refreshDicts(store, segs, hold) {
    let n = 0
    for (const seg of segs) {
        const is = store.itemsSource && store.itemsSource[seg]
        if (!is) continue
        if (hold) is._i18nHold = true
        try { store.get_itemsSource_bySegment(seg, { fetchMode: 'refresh' }); n++ } catch (e) { delete is._i18nHold; console.warn('[i18n] itemsSource refresh', seg, e) }
    }
    return n
}
// снять удержание: одна волна бампов (Vue сводит вотчеры гридов в один проход)
function _releaseHold(store, segs) {
    const held = store._i18nHeldSegs || new Set()
    store._i18nHeldSegs = null
    for (const seg of segs) { const is = store.itemsSource && store.itemsSource[seg]; if (is) delete is._i18nHold }
    let n = 0
    for (const seg of held) {
        const is = store.itemsSource && store.itemsSource[seg]
        if (!is) continue
        try { if (typeof store.itemsSource_bump === 'function') { store.itemsSource_bump(is); n++ } } catch (e) { console.warn('[i18n] itemsSource bump', seg, e) }
    }
    return n
}
async function relocalizeData(store, base, info, P = null, flags = null) {   // IE 2026 09 25 / ODOO-341407: + P (ход переключения), flags
    const t0 = performance.now()
    flags = flags || _flags(store)
    const ctx = { from: base.from, to: base.to, T: base.T, Tfrom: base.Tfrom, R: base.R, store, seen: new WeakSet(), n: 0, bySeg: {}, targets: [] }
    try {
        collectMenu(store.menuTree, ctx, store)
        for (const WS of Object.values(store.WORKSPACES || {})) {
            if (!WS || typeof WS !== 'object') continue
            collectPageLinks(WS, ctx, store)   // IE 2026 10 01 / ODOO-341407: узлы страниц и пункты-виджеты меню страницы
            collectRows(WS.record && WS.record.doc && WS.record.doc.pages, ctx, store)
            for (const W of WS.ALL_WIDGETS || []) { try { collectWidget(W, ctx, store) } catch (e) { console.warn('[i18n] data widget', W && W.id, e) } }
        }
        for (const W of Object.values(store.WIDGETS || {})) { try { collectWidget(W, ctx, store) } catch (e) { console.warn('[i18n] data widget', W && W.id, e) } }
    } catch (e) { console.warn('[i18n] data collect', e) }
    if (P) P.dicts = true
    const hold = !!flags.switchDictsCoalesce && typeof store.itemsSource_bump === 'function'
    if (hold) store._i18nHeldSegs = store._i18nHeldSegs || new Set()
    let segments = 0, refreshed = 0
    const heldSegs = []
    for (const [seg, ids] of Object.entries(ctx.bySeg)) {
        try {
            store.get_itemsSource({}, {}, { attr_type: 'AttrLink', relation_segment: seg }, { ids: [...ids] }); segments++
            const is = store.itemsSource && store.itemsSource[seg]
            if (hold && is) { is._i18nHold = true; heldSegs.push(seg) }
        } catch (e) { console.warn('[i18n] itemsSource', seg, e) }
    }
    // IE 2026 09 25 / ODOO-341407 (switchDictsAfterData, замер dev02: 3 запроса словарей одновременно с 4 тяжёлыми select'ами — очередь бэка и
    // CPU делятся, и данные, и словари дольше): словари, используемые на странице, — после данных страницы (подписи строк отчётов уже новые,
    // названия ссылок доезжают следом — индикатор «Updating reference titles…»)
    // IE 2026 09 25 / ODOO-341407 (проверка dev02: ссылки MEASURE отчёта Sales$ оставались на прежнем языке до фонового перечитывания — в момент
    // «данные пришли» грид отчёта пересобирался и его колонок в подсчёте не было): используемые сегменты — ДО ожидания данных (прежние колонки) и
    // после (новые), объединением
    const used0 = flags.switchDictsScoped ? _usedSegments(store) : null
    if (flags.switchDictsAfterData && P) { switchProgress.phase = 'data'; await progressWidgetsDone(P) }
    const used = flags.switchDictsScoped ? new Set([...used0, ..._usedSegments(store)]) : null
    const now = [], later = []
    for (const [seg, is] of Object.entries(store.itemsSource || {})) {
        if (!is || typeof is !== 'object' || is.segment !== seg || !Array.isArray(is.data) || !is.data.length || is.data.length > DATA_REFRESH_MAX) continue
        if (DATA_REFRESH_SKIP.includes(seg)) continue
        if (used && !used.has(seg) && !ctx.bySeg[seg]) later.push(seg)
        else now.push(seg)
    }
    refreshed = _refreshDicts(store, now, hold)
    if (hold) heldSegs.push(...now)
    const waited = (segments || refreshed) ? await _awaitItemsSources(store) : 0
    const coalesced = hold ? _releaseHold(store, heldSegs) : 0
    let applied = 0
    for (const tg of ctx.targets) {
        const is = store.itemsSource && store.itemsSource[tg.seg]
        const title = is && is.ids && is.ids[tg.id] && is.ids[tg.id].title
        if (typeof title === 'string' && title) { try { tg.apply(title); applied++ } catch (e) { /* узел исчез */ } }
    }
    try {
        for (const rw of store.recentWorkspaces || []) { const ws = store.WORKSPACES && store.WORKSPACES[rw.workspace]; if (ws && typeof ws.title === 'string' && ws.title) rw.label = ws.title }
        if (Array.isArray(store.menuTree) && typeof store.menu_push === 'function') { store.menuTree_model = []; for (const node of store.menuTree) store.menu_push(store.menuTree_model, node) }
    } catch (e) { console.warn('[i18n] menuTree_model', e) }
    Object.assign(info, { dataMs: Math.round(performance.now() - t0), dataRelabelled: ctx.n, dataTargets: ctx.targets.length, dataApplied: applied, dataSegments: segments, dataRefreshed: refreshed,
        dataWaitMs: waited, dataBackground: later.length, dataCoalesced: coalesced })
    if (P) P.dicts = false
    bumpLangVersion()
    emitChanged('data', info)
    console.log(`[i18n] data relabelled for ${ctx.to}: ${ctx.n} labels (${applied}/${ctx.targets.length} record titles by id, ${segments} segments asked, ${refreshed} dictionaries refreshed${later.length ? `, ${later.length} more in the background after the switch` : ''}${coalesced ? `, grids redrawn once for ${coalesced}` : ''}, wait ${waited} ms) in ${info.dataMs} ms`)
    // IE 2026 09 25 / ODOO-341407 (switchDictsScoped): остальные закэшированные словари — после завершения переключения (данные страницы не ждут их в очереди бэка)
    if (later.length) {
        // по готовности — событие 'i18n:changed' phase 'dicts': гриды (в т.ч. страниц в KeepAlive, где вотчер словарей не отрабатывает) перепривязывают
        // dataMap ссылочных колонок (AttrGrid.i18n_rebindDataMaps)
        const bg = async () => {
            const n = _refreshDicts(store, later, false)
            const w = n ? await _awaitItemsSources(store) : 0
            emitChanged('dicts', { lang: ctx.to, n })
            console.log(`[i18n] ${n} dictionaries not used on the page re-read in the background for ${ctx.to} (${w} ms)`)
        }
        if (P && P === _prog && P.timer) P.onDone.push(bg)
        else setTimeout(bg, 0)
    }
    return info
}

// IE 2026 09 25 / ODOO-341407: уступить кадр отрисовке (индикатор хода переключения) между тяжёлыми синхронными шагами
// (кадр или 50 мс — во вкладке в фоне requestAnimationFrame не приходит)
const _paint = () => new Promise((resolve) => {
    let done = false
    const fin = () => { if (!done) { done = true; setTimeout(resolve, 0) } }
    try { requestAnimationFrame(fin) } catch (e) { /* без rAF */ }
    setTimeout(fin, 50)
})
let _running = null
// главный проход: словари (from — для обратной карты, to — для перевода), структуры стора, событие 'i18n:changed' (phase 'attrs'),
// langVersion++ (перерисовка), select отчётов, затем подписи записей по id (phase 'data'). Возвращает замеры. Параллельные вызовы сериализуются
// IE 2026 09 25 / ODOO-341407: t0 — момент клика (замеры фаз от него), ui — замеры смены строк интерфейса (switchLanguageLive);
// ход и завершение — индикатор (switchProgress), итог — window.i18nSwitch.last() и строка «[i18n] switch to … complete in … ms»
export function relocalize(store, { from, to, refreshData = true, relabelData = true, t0 = 0, ui = null } = {}) {   // IE 2026 09 24 / ODOO-341407: relabelData — проход по id
    const run = async () => {
        const T0 = t0 || performance.now()
        const rel = () => Math.round(performance.now() - T0)
        const info = { from, to, attrs: 0, widgets: 0, dictMs: 0, ms: 0, refreshed: 0, kept: 0, error: '', t: { ui: ui && typeof ui.ms === 'number' ? rel() : undefined } }
        if (!store || !to || from === to) return info
        const flags = _flags(store)
        const P = progressBegin(store, { to, t0: T0, mode: 'switch', on: flags.switchProgress })
        P.info = info
        if (flags.switchProgress) await _paint()   // IE 2026 09 25 / ODOO-341407: индикатор показывается до тяжёлых синхронных шагов (проход подписей, сборка запросов)
        const tStart = performance.now()
        let entryTo = null, entryFrom = null
        try {
            const td = performance.now()
            ;[entryTo, entryFrom] = await Promise.all([dictGet(store, to), from ? dictGet(store, from).catch(() => null) : null])
            info.dictMs = Math.round(performance.now() - td)
            info.dictKeys = Object.keys(entryTo.dict || {}).length
            info.t.dict = rel()
        } catch (e) {
            info.error = String(e && e.message || e)
            info.ms = Math.round(performance.now() - tStart)
            console.warn(`[i18n] relocalize: backend dictionary unavailable — server labels update on the next refresh (${info.error})`)
            try { store.TERMINAL(null, null, { text: tFe('Backend dictionary unavailable — labels from the server update on the next refresh'), status: 'warning' }) } catch (e2) { /* без панели */ }
            switchProgress.error = tFe('Backend dictionary unavailable — labels from the server update on the next refresh')   // IE 2026 09 25 / ODOO-341407
            emitChanged('attrs', info)
            bumpLangVersion()
            P.walkDone = true
            return info
        }
        const ctx = { from, to, T: _makeT(entryTo, to), Tfrom: _makeT(entryFrom, from), R: from && from !== LANGUAGE_DEFAULT ? _reverse(entryFrom) : null, store, seen: new WeakSet(), n: 0, widgets: 0 }
        const tw = performance.now()
        switchProgress.phase = 'labels'
        for (const [wsId, WS] of Object.entries(store.WORKSPACES || {})) { try { relocalizeWorkspace(WS, ctx) } catch (e) { console.warn('[i18n] workspace', wsId, e) } }
        for (const W of Object.values(store.WIDGETS || {})) { try { relocalizeWidget(W, ctx) } catch (e) { console.warn('[i18n] widget', W && W.id, e) } }
        try { relabelRowForms(store, ctx) } catch (e) { console.warn('[i18n] row forms', e) }   // IE 2026 09 24 / ODOO-341407: шапка / заголовок форм строки
        try { walkAttrs(store.menuTree, ctx); walkAttrs(store.process_model_menu, ctx) } catch (e) { console.warn('[i18n] menus', e) }
        try {
            // рейл-меню столов: модель — копия узлов menuTree (label), пересобирается как при смене процессной модели
            if (Array.isArray(store.menuTree) && typeof store.menu_push === 'function') {
                store.menuTree_model = []
                for (const node of store.menuTree) store.menu_push(store.menuTree_model, node)
            }
        } catch (e) { console.warn('[i18n] menuTree_model', e) }
        info.attrs = ctx.n; info.widgets = ctx.widgets
        info.walkMs = Math.round(performance.now() - tw)
        info.t.walk = rel()
        info.ms = Math.round(performance.now() - tStart)
        bumpLangVersion()
        emitChanged('attrs', info)
        info.t.attrs = rel()
        P.walkDone = true
        // IE 2026 09 25 / ODOO-341407: перезапросы — после прохода подписей, как раньше: вариант «сначала перезапросы» (switchRefreshFirst) замерен на dev02
        // 25.09 (2×2 переключения): итог тот же (15,3 против 16,0 с), подписи бэка — на 1,7 с позже (сборка запросов идёт до прохода), — снят
        if (refreshData) { Object.assign(info, refreshDataWidgets(store, ctx, P, flags)); info.t.sent = rel() }   // IE 2026 09 24 / ODOO-341407: отчёты и списки
        console.log(`[i18n] switched to ${to} in ${info.ms} ms (dict ${info.dictMs} ms, ${info.attrs} attrs relabelled in ${info.widgets} widgets, walk ${info.walkMs} ms${info.refreshed ? `, ${info.refreshed} data widgets refreshed` : ''}${info.kept ? `, ${info.kept} with unsaved edits kept` : ''}${info.keptForm ? `, ${info.keptForm} with an open row form kept` : ''}${info.hidden ? `, ${info.hidden} hidden (refresh on restore)` : ''}${info.otherPages ? `, ${info.otherPages} data widgets on other pages refresh on activation` : ''}${info.byKind && Object.keys(info.byKind).length ? ` [${_kinds(info.byKind)}]` : ''})`)   // IE 2026 09 24 / ODOO-341407: + отчёты неактивных страниц; + списки, по видам
        if (relabelData) { try { await relocalizeData(store, ctx, info, P, flags) } catch (e) { P.dicts = false; console.warn('[i18n] data relabel', e) } }   // IE 2026 09 24 / ODOO-341407: рейка столов, панель страниц, дерево настроек, строки гридов
        info.t.data = rel()
        return info
    }
    _running = (_running || Promise.resolve()).then(run, run)
    return _running
}

export { retranslate }
